import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import orderBy from 'lodash/orderBy';
import TextButton from '../TextButton';
import { filterSentence, mapKeyToText, getProductNameFromTokenId } from '../../utils';
import { geographies as constGeos, channels as constChannels } from '../../constants';
import styles from './FilterList.style';

const FilterList = ({
  className: classNameProp,
  filters,
  products: filteredProducts,
  onRemove,
}) => {
  const classNames = clsx(styles.filterList, classNameProp);
  const filterList = orderBy(filters, ['createdTimeStamp'], ['asc']);
  return (
    <ul className={classNames}>
      {filterList.map(
        ({ address, type, geographies, channels, currencies, products } = filterList) => (
          <li key={address} className={styles.filterListRow}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={filterSentence({
                channels: mapKeyToText(channels, constChannels),
                currencies,
                geographies: mapKeyToText(geographies, constGeos),
                products: getProductNameFromTokenId(filteredProducts, products),
                type,
              })}
            />
            {onRemove && (
              <div className={styles.actionButtonContainer}>
                <IconButton
                  iconProps={{ iconName: 'Cancel' }}
                  title="Remove"
                  ariaLabel="Remove"
                  className={clsx(styles.actionButton, styles.mobileRemoveButton)}
                  onClick={() => onRemove(address)}
                />
                <TextButton
                  onClick={() => onRemove(address)}
                  className={clsx(styles.actionButton, styles.desktopRemoveButton)}
                  noPadding
                >
                  Remove
                </TextButton>
              </div>
            )}
          </li>
        ),
      )}
    </ul>
  );
};

FilterList.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string.isRequired,
      channels: PropTypes.arrayOf(PropTypes.string),
      currencies: PropTypes.arrayOf(PropTypes.string),
      geographies: PropTypes.arrayOf(PropTypes.string),
      products: PropTypes.arrayOf(PropTypes.number),
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      tokenId: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onRemove: PropTypes.func,
};

FilterList.defaultProps = {
  className: '',
  onRemove: null,
};

export default FilterList;
